import { render } from "../views/banner.html?vue&type=template&id=6ea5828e&ts=true&external"
import script from "../scripts/banner.ts?vue&type=script&lang=ts&external"
export * from "../scripts/banner.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/banner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ea5828e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ea5828e', __exports__)) {
    api.reload('6ea5828e', __exports__)
  }
  
  module.hot.accept("../views/banner.html?vue&type=template&id=6ea5828e&ts=true&external", () => {
    api.rerender('6ea5828e', render)
  })

}


export default __exports__